<template>
<div>
  <h2 class="mb-4">{{ $t('workScheduling.dailySchedule') }}</h2>
  <daily-schedule-container />
</div>
</template>
<script lang="ts">
import { defineComponent } from 'vue'
import DailyScheduleContainer from '@/containers/work-schedule/DailyScheduleContainer.vue'

export default defineComponent({
  components: {
    DailyScheduleContainer,
  }
})
</script>
